import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SyncState {
  isSyncingPortfolioAndCustodian: boolean;
  setSyncingPortfolioAndCustodian: (loading: boolean) => void;
  isSyncingOTCDatabase: boolean;
  setSyncingOTCDatabase: (loading: boolean) => void;
}

export const useSyncStore = create<SyncState>()(
  devtools(
    set => ({
      isSyncingPortfolioAndCustodian: false,
      setSyncingPortfolioAndCustodian: (loading: boolean) =>
        set({ isSyncingPortfolioAndCustodian: loading }),
      isSyncingOTCDatabase: false,
      setSyncingOTCDatabase: (loading: boolean) =>
        set({ isSyncingOTCDatabase: loading }),
    }),
    { name: 'sync-store' }
  )
);
